import { findHashes } from "./findHashes"
import { getHTMLWithLinkedTags } from "./getHTMLWithLinkedTags"

export const getHashtagsFromHTML = (html: string, linkifyHTML = false) => {
  let tagged: string[] = []
  let correctHTML = html

  const parsedHTMLEle = document.createElement('div')
  parsedHTMLEle.innerHTML = html

  const textContent = parsedHTMLEle.textContent

  tagged = findHashes(html) || []

  linkifyHTML && (correctHTML = getHTMLWithLinkedTags(textContent))

  const tags = Array.from(new Set(tagged.map(tag => tag.replace('#', ''))))

  return {
    tags,
    html: correctHTML
  }
}
